<div class="footer pt-1 px-2">
    <a [routerLink]="['impressum']">{{ 'Impressum' | translate }}</a>
</div>